module.exports = __webpack_public_path__ + "assets/img/VIP.604c70ae.png";